import type { SelectedProductVariants } from '@/ui/components/pages/ProductDetail/types/SelectedProductVariants';
import type { BundleProduct } from '../BundleProductService';

/**
 * Moves every slot left on a variant the country hides to its sole visible option, as the
 * product page does, so the pickers, the gallery and the URL show what the visitor can buy.
 * The skipped product keeps its variant because another picker owns it. Returns the given
 * object when nothing moves, so a caller can tell a no-op apart without comparing slots.
 */
export function snapSelectionToCountry(
  products: BundleProduct[],
  selected: SelectedProductVariants,
  country?: string | null,
  options: { skipProductId?: string } = {},
): SelectedProductVariants {
  let snappedSelection = selected;

  products.forEach((product) => {
    if (product.id === options.skipProductId) {
      return;
    }

    const snapped = product.getCountrySnapVariant(product.resolveVariant(selected), country);
    if (snapped) {
      snappedSelection = { ...snappedSelection, [product.bundleProductInstanceId]: snapped };
    }
  });

  return snappedSelection;
}
